export const FEATURE_ANNOUNCEMENT_KEYS = {
  STORY_CARD_SETTINGS_UI: "story-card-settings-ui",
} as const;

export type FeatureAnnouncementKey = typeof FEATURE_ANNOUNCEMENT_KEYS[keyof typeof FEATURE_ANNOUNCEMENT_KEYS];
